import PedegreeMatrix from "../../components/PedegreeMatrix/PedegreeMatrix";
import "../PageCommon.css";
import "./PedegreeMatrix.css";

const PedegreeMatrixPage = () => {
  return (
    <div className="page__container">
      <div className="page__head">
      </div>
      <div className="page__body">
        <PedegreeMatrix />
      </div>
    </div>
  );
}

export default PedegreeMatrixPage;